export const states = [
  {
    id: 1,
    name: "Andhra Pradesh",
    cities: [
      "Visakhapatnam",
      "Vijayawada",
      "Guntur",
      "Nellore",
      "Kurnool",
      "Rajahmundry",
      "Tirupati",
      "Kakinada",
      "Kadapa",
      "Anantapur",
      "Eluru",
      "Ongole",
      "Nandyal",
      "Machilipatnam",
      "Adoni",
      "Tenali",
      "Chittoor",
      "Hindupur",
      "Proddatur",
      "Bhimavaram",
    ],
  },
  {
    id: 2,
    name: "Arunachal Pradesh",
    cities: [
      "Itanagar",
      "Naharlagun",
      "Pasighat",
      "Tawang",
      "Ziro",
      "Daporijo",
      "Tezu",
      "Bomdila",
      "Along",
      "Khonsa",
    ],
  },
  {
    id: 3,
    name: "Assam",
    cities: [
      "Guwahati",
      "Silchar",
      "Dibrugarh",
      "Jorhat",
      "Nagaon",
      "Tinsukia",
      "Tezpur",
      "Bongaigaon",
      "Dhubri",
      "Diphu",
      "North Lakhimpur",
      "Karimganj",
      "Goalpara",
      "Sivasagar",
      "Barpeta",
      "Hailakandi",
      "Golaghat",
      "Morigaon",
      "Mangaldoi",
      "Kokrajhar",
    ],
  },
  {
    id: 4,
    name: "Bihar",
    cities: [
      "Patna",
      "Gaya",
      "Bhagalpur",
      "Muzaffarpur",
      "Purnia",
      "Darbhanga",
      "Bihar Sharif",
      "Arrah",
      "Begusarai",
      "Katihar",
      "Munger",
      "Chapra",
      "Saharsa",
      "Hajipur",
      "Sasaram",
      "Dehri",
      "Bettiah",
      "Motihari",
      "Siwan",
      "Kishanganj",
    ],
  },
  {
    id: 5,
    name: "Chhattisgarh",
    cities: [
      "Raipur",
      "Bhilai",
      "Bilaspur",
      "Korba",
      "Durg",
      "Rajnandgaon",
      "Raigarh",
      "Jagdalpur",
      "Ambikapur",
      "Dhamtari",
      "Chirmiri",
      "Bhatapara",
      "Dalli-Rajhara",
      "Mahasamund",
      "Kanker",
      "Janjgir",
      "Kawardha",
      "Mungeli",
      "Sakti",
      "Tilda",
    ],
  },
  {
    id: 6,
    name: "Goa",
    cities: [
      "Panaji",
      "Vasco da Gama",
      "Margao",
      "Mapusa",
      "Ponda",
      "Bicholim",
      "Curchorem",
      "Sanquelim",
      "Valpoi",
      "Canacona",
    ],
  },
  {
    id: 7,
    name: "Gujarat",
    cities: [
      "Ahmedabad",
      "Surat",
      "Vadodara",
      "Rajkot",
      "Bhavnagar",
      "Jamnagar",
      "Gandhinagar",
      "Junagadh",
      "Gandhidham",
      "Anand",
      "Navsari",
      "Morbi",
      "Nadiad",
      "Surendranagar",
      "Bharuch",
      "Mehsana",
      "Bhuj",
      "Porbandar",
      "Palanpur",
      "Valsad",
    ],
  },
  {
    id: 8,
    name: "Haryana",
    cities: [
      "Faridabad",
      "Gurgaon",
      "Panipat",
      "Ambala",
      "Yamunanagar",
      "Rohtak",
      "Hisar",
      "Karnal",
      "Sonipat",
      "Panchkula",
      "Bhiwani",
      "Sirsa",
      "Bahadurgarh",
      "Jind",
      "Thanesar",
      "Kaithal",
      "Rewari",
      "Palwal",
      "Hansi",
      "Narnaul",
    ],
  },
  {
    id: 9,
    name: "Himachal Pradesh",
    cities: [
      "Shimla",
      "Mandi",
      "Solan",
      "Dharamshala",
      "Bilaspur",
      "Kullu",
      "Chamba",
      "Palampur",
      "Nahan",
      "Hamirpur",
      "Una",
      "Kangra",
      "Nalagarh",
      "Paonta Sahib",
      "Sundarnagar",
      "Kasauli",
      "Manali",
      "Dalhousie",
      "Kullu",
      "Parwanoo",
    ],
  },
  {
    id: 10,
    name: "Jharkhand",
    cities: [
      "Ranchi",
      "Jamshedpur",
      "Dhanbad",
      "Bokaro Steel City",
      "Hazaribagh",
      "Deoghar",
      "Giridih",
      "Ramgarh",
      "Medininagar",
      "Chaibasa",
      "Gumla",
      "Lohardaga",
      "Pakur",
      "Simdega",
      "Sahibganj",
      "Godda",
      "Koderma",
      "Chatra",
      "Garhwa",
      "Latehar",
    ],
  },
  {
    id: 11,
    name: "Karnataka",
    cities: [
      "Bangalore",
      "Mysore",
      "Hubli",
      "Mangalore",
      "Belgaum",
      "Gulbarga",
      "Davangere",
      "Bellary",
      "Bijapur",
      "Shimoga",
      "Tumkur",
      "Raichur",
      "Bidar",
      "Hospet",
      "Hassan",
      "Mandya",
      "Chitradurga",
      "Udupi",
      "Kolar",
      "Gadag",
    ],
  },
  {
    id: 12,
    name: "Kerala",
    cities: [
      "Kochi",
      "Thiruvananthapuram",
      "Kozhikode",
      "Thrissur",
      "Malappuram",
      "Kannur",
      "Kollam",
      "Alappuzha",
      "Palakkad",
      "Kottayam",
      "Pathanamthitta",
      "Idukki",
      "Wayanad",
      "Kasaragod",
      "Ernakulam",
      "Kottayam",
      "Manjeri",
      "Thalassery",
      "Ponnani",
      "Kayamkulam",
    ],
  },
  {
    id: 13,
    name: "Madhya Pradesh",
    cities: [
      "Indore",
      "Bhopal",
      "Gwalior",
      "Jabalpur",
      "Raipur",
      "Ujjain",
      "Sagar",
      "Dewas",
      "Satna",
      "Ratlam",
      "Rewa",
      "Murwara",
      "Singrauli",
      "Burhanpur",
      "Khandwa",
      "Morena",
      "Bhind",
      "Chhindwara",
      "Guna",
      "Shivpuri",
    ],
  },
  {
    id: 14,
    name: "Maharashtra",
    cities: [
      "Mumbai",
      "Pune",
      "Nagpur",
      "Thane",
      "Nashik",
      "Aurangabad",
      "Solapur",
      "Amravati",
      "Kolhapur",
      "Sangli",
      "Jalgaon",
      "Akola",
      "Latur",
      "Ahmednagar",
      "Chandrapur",
      "Parbhani",
      "Ichalkaranji",
      "Jalna",
      "Bhusawal",
      "Panvel",
    ],
  },
  {
    id: 15,
    name: "Manipur",
    cities: [
      "Imphal",
      "Thoubal",
      "Bishnupur",
      "Churachandpur",
      "Kakching",
      "Ukhrul",
      "Senapati",
      "Tamenglong",
      "Jiribam",
      "Chandel",
    ],
  },
  {
    id: 16,
    name: "Meghalaya",
    cities: [
      "Shillong",
      "Tura",
      "Jowai",
      "Nongpoh",
      "Baghmara",
      "Williamnagar",
      "Resubelpara",
      "Mairang",
      "Mankachar",
      "Amlarem",
    ],
  },
  {
    id: 17,
    name: "Mizoram",
    cities: [
      "Aizawl",
      "Lunglei",
      "Saiha",
      "Champhai",
      "Kolasib",
      "Serchhip",
      "Lawngtlai",
      "Mamit",
      "Khawzawl",
      "Hnahthial",
    ],
  },
  {
    id: 18,
    name: "Nagaland",
    cities: [
      "Dimapur",
      "Kohima",
      "Mokokchung",
      "Tuensang",
      "Wokha",
      "Mon",
      "Phek",
      "Zunheboto",
      "Kiphire",
      "Longleng",
    ],
  },
  {
    id: 19,
    name: "Odisha",
    cities: [
      "Bhubaneswar",
      "Cuttack",
      "Rourkela",
      "Berhampur",
      "Sambalpur",
      "Puri",
      "Balasore",
      "Bhadrak",
      "Baripada",
      "Jharsuguda",
      "Bargarh",
      "Rayagada",
      "Jeypore",
      "Bhawanipatna",
      "Dhenkanal",
      "Angul",
      "Kendujhar",
      "Paradip",
      "Talcher",
      "Phulbani",
    ],
  },
  {
    id: 20,
    name: "Punjab",
    cities: [
      "Ludhiana",
      "Amritsar",
      "Jalandhar",
      "Patiala",
      "Bathinda",
      "Pathankot",
      "Hoshiarpur",
      "Batala",
      "Moga",
      "Abohar",
      "Malerkotla",
      "Khanna",
      "Mohali",
      "Barnala",
      "Firozpur",
      "Phagwara",
      "Kapurthala",
      "Sangrur",
      "Faridkot",
      "Gurdaspur",
    ],
  },
  {
    id: 21,
    name: "Rajasthan",
    cities: [
      "Jaipur",
      "Jodhpur",
      "Kota",
      "Bikaner",
      "Ajmer",
      "Udaipur",
      "Bhilwara",
      "Alwar",
      "Bharatpur",
      "Sikar",
      "Tonk",
      "Pali",
      "Hanumangarh",
      "Beawar",
      "Dungarpur",
      "Chittorgarh",
      "Sri Ganganagar",
      "Baran",
      "Banswara",
      "Jhunjhunu",
    ],
  },
  {
    id: 22,
    name: "Sikkim",
    cities: [
      "Gangtok",
      "Namchi",
      "Mangan",
      "Gyalshing",
      "Singtam",
      "Rangpo",
      "Jorethang",
      "Ravangla",
      "Pakyong",
      "Soreng",
    ],
  },
  {
    id: 23,
    name: "Tamil Nadu",
    cities: [
      "Chennai",
      "Coimbatore",
      "Madurai",
      "Tiruchirappalli",
      "Salem",
      "Tirunelveli",
      "Erode",
      "Vellore",
      "Thoothukudi",
      "Dindigul",
      "Thanjavur",
      "Hosur",
      "Nagercoil",
      "Kanchipuram",
      "Karaikudi",
      "Neyveli",
      "Cuddalore",
      "Kumbakonam",
      "Tiruppur",
      "Ooty",
    ],
  },
  {
    id: 24,
    name: "Telangana",
    cities: [
      "Hyderabad",
      "Warangal",
      "Nizamabad",
      "Karimnagar",
      "Ramagundam",
      "Khammam",
      "Mahbubnagar",
      "Nalgonda",
      "Adilabad",
      "Siddipet",
      "Suryapet",
      "Miryalaguda",
      "Jagtial",
      "Kamareddy",
      "Kothagudem",
      "Bhongir",
      "Bodhan",
      "Narayanpet",
      "Mancherial",
      "Sangareddy",
    ],
  },
  {
    id: 25,
    name: "Tripura",
    cities: [
      "Agartala",
      "Udaipur",
      "Dharmanagar",
      "Kailasahar",
      "Belonia",
      "Khowai",
      "Ambassa",
      "Sabroom",
      "Kamalpur",
      "Teliamura",
    ],
  },
  {
    id: 26,
    name: "Uttar Pradesh",
    cities: [
      "Lucknow",
      "Kanpur",
      "Ghaziabad",
      "Agra",
      "Meerut",
      "Varanasi",
      "Allahabad",
      "Bareilly",
      "Aligarh",
      "Moradabad",
      "Saharanpur",
      "Gorakhpur",
      "Noida",
      "Firozabad",
      "Jhansi",
      "Muzaffarnagar",
      "Mathura",
      "Rampur",
      "Shahjahanpur",
      "Farrukhabad",
    ],
  },
  {
    id: 27,
    name: "Uttarakhand",
    cities: [
      "Dehradun",
      "Haridwar",
      "Roorkee",
      "Haldwani",
      "Rudrapur",
      "Kashipur",
      "Rishikesh",
      "Ramnagar",
      "Pithoragarh",
      "Manglaur",
      "Nainital",
      "Mussoorie",
      "Almora",
      "Pauri",
      "Chamoli",
      "Bageshwar",
      "Champawat",
      "Udham Singh Nagar",
      "Tehri",
      "Uttarkashi",
    ],
  },
  {
    id: 28,
    name: "West Bengal",
    cities: [
      "Kolkata",
      "Howrah",
      "Durgapur",
      "Asansol",
      "Siliguri",
      "Bardhaman",
      "Malda",
      "Baharampur",
      "Habra",
      "Kharagpur",
      "Shantiniketan",
      "Darjeeling",
      "Alipore",
      "Jalpaiguri",
      "Krishnanagar",
      "Barasat",
      "Bangaon",
      "Cooch Behar",
      "English Bazar",
      "Raiganj",
    ],
  },
  {
    id: 29,
    name: "Andaman and Nicobar Islands",
    cities: [
      "Port Blair",
      "Diglipur",
      "Mayabunder",
      "Rangat",
      "Car Nicobar",
      "Hut Bay",
      "Bamboo Flat",
      "Garacharma",
      "Prothrapur",
      "Bakultala",
    ],
  },
  {
    id: 30,
    name: "Chandigarh",
    cities: [
      "Chandigarh",
      "Sector 17",
      "Sector 35",
      "Sector 22",
      "Manimajra",
      "Sector 34",
      "Sector 43",
      "Sector 19",
      "Sector 38",
      "Sector 46",
    ],
  },
  {
    id: 31,
    name: "Dadra and Nagar Haveli and Daman and Diu",
    cities: [
      "Daman",
      "Diu",
      "Silvassa",
      "Vapi",
      "Naroli",
      "Amli",
      "Khanvel",
      "Dadra",
      "Masat",
      "Rakholi",
    ],
  },
  {
    id: 32,
    name: "Delhi",
    cities: [
      "New Delhi",
      "North Delhi",
      "South Delhi",
      "East Delhi",
      "West Delhi",
      "Central Delhi",
      "North East Delhi",
      "North West Delhi",
      "South West Delhi",
      "Shahdara",
    ],
  },
  {
    id: 33,
    name: "Jammu and Kashmir",
    cities: [
      "Srinagar",
      "Jammu",
      "Anantnag",
      "Baramulla",
      "Sopore",
      "Kathua",
      "Udhampur",
      "Poonch",
      "Rajouri",
      "Kupwara",
      "Pulwama",
      "Budgam",
      "Ganderbal",
      "Bandipora",
      "Kulgam",
      "Shopian",
      "Doda",
      "Ramban",
      "Reasi",
      "Kishtwar",
    ],
  },
  {
    id: 34,
    name: "Ladakh",
    cities: [
      "Leh",
      "Kargil",
      "Drass",
      "Nubra Valley",
      "Pangong",
      "Hemis",
      "Alchi",
      "Diskit",
      "Nyoma",
      "Turtuk",
    ],
  },
  {
    id: 35,
    name: "Lakshadweep",
    cities: [
      "Kavaratti",
      "Agatti",
      "Amini",
      "Andrott",
      "Bitra",
      "Chettat",
      "Kadmat",
      "Kalpeni",
      "Kiltan",
      "Minicoy",
    ],
  },
  {
    id: 36,
    name: "Puducherry",
    cities: [
      "Puducherry",
      "Karaikal",
      "Mahe",
      "Yanam",
      "Ozhukarai",
      "Villianur",
      "Bahour",
      "Nettapakkam",
      "Ariyankuppam",
      "Muthialpet",
    ],
  },
];
